"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_CAFE24_CATE_LIST = void 0;
var API_CAFE24_CATE_LIST;
(function (API_CAFE24_CATE_LIST) {
    API_CAFE24_CATE_LIST.PATH = '/cafe24/cate-list';
    API_CAFE24_CATE_LIST.PURPOSE = '카페24 카테고리 목록조회';
})(API_CAFE24_CATE_LIST = exports.API_CAFE24_CATE_LIST || (exports.API_CAFE24_CATE_LIST = {}));
//# sourceMappingURL=api-cate.js.map